<template lang="pug">
  b-modal#addRescueFund(
    ref="addRescueFund"
    :title="$t('ui.combine.add_rescue_fund')"
    centered
    no-fade
    no-close-on-backdrop
    size="lg"
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-card
        div.row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.id')").mb-0
              DebounceInput(
                size="sm"
                ref="rescue_id"
                required
                type="text"
                :dirty="$v.rescue_id.$dirty"
                :error="$v.rescue_id.$error"
                v-model.trim.lazy="$v.rescue_id.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.rescue_id" :name="$t('ui.id')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.name')").mb-0
              DebounceInput(
                size="sm"
                ref="rescue_name"
                required
                type="text"
                :dirty="$v.rescue_name.$dirty"
                :error="$v.rescue_name.$error"
                v-model.trim.lazy="$v.rescue_name.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.rescue_name" :name="$t('ui.name')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.cycle')").mb-0
              RescueCycle(
                ref="rescue_cycle"
                size="sm"
                required
                type="array"
                :dirty="$v.rescue_cycle.$dirty"
                :error="$v.rescue_cycle.$error"
                v-model.trim.lazy="$v.rescue_cycle.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.rescue_cycle" :name="$t('ui.cycle')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.rate_percent')").mb-0
              DebounceInput(
                size="sm"
                ref="rescue_rate"
                required
                type="text"
                :dirty="$v.rescue_rate.$dirty"
                :error="$v.rescue_rate.$error"
                v-model.trim.lazy="$v.rescue_rate.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.rescue_rate" :name="$t('ui.rate_percent')")
        .row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.min_lose')").mb-0
              DebounceInput(
                size="sm"
                ref="min_lose"
                required
                type="text"
                :dirty="$v.min_lose.$dirty"
                :error="$v.min_lose.$error"
                v-model.trim.lazy="$v.min_lose.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.min_lose" :name="$t('ui.min_lose')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.max_payout')").mb-0
              DebounceInput(
                size="sm"
                ref="max_payout"
                required
                type="text"
                :dirty="$v.max_payout.$dirty"
                :error="$v.max_payout.$error"
                v-model.trim.lazy="$v.max_payout.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.max_payout" :name="$t('ui.max_payout')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.payout_method')").mb-0
              PayoutMethod(
                ref="payout_method"
                size="sm"
                required
                type="array"
                :dirty="$v.payout_method.$dirty"
                :error="$v.payout_method.$error"
                v-model.trim.lazy="$v.payout_method.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.payout_method" :name="$t('ui.payout_method')")
          div.col-sm-12.col-md-3.col-lg-3(v-if="['INBOX'].includes(payout_method)")
            b-form-group(:label="$t('ui.campaign_id')").mb-0
              CampaignLookup(
                size="sm"
                ref="campaign_id"
                required
                type="array"
                :dirty="$v.campaign_id.$dirty"
                :error="$v.campaign_id.$error"
                v-model.trim.lazy="$v.campaign_id.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
        .row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.start_date')").mb-0
              b-input-group(size="sm")
                date-picker(
                  ref="start_date"
                  :config="localeDate"
                  :dirty="$v.start_date.$dirty"
                  :error="$v.start_date.$error"
                  v-model.trim.lazy="$v.start_date.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.end_date')").mb-0
              b-input-group(size="sm")
                date-picker(
                  ref="end_date"
                  :config="localeDate"
                  :dirty="$v.end_date.$dirty"
                  :error="$v.end_date.$error"
                  v-model.trim.lazy="$v.end_date.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.target_group')").mb-0
              TargetGroup(
                ref="target_group"
                size="sm"
                required
                type="array"
                :dirty="$v.target_group.$dirty"
                :error="$v.target_group.$error"
                v-model.trim.lazy="$v.target_group.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.target_group" :name="$t('ui.target_group')")
        .row
          div.col-sm-12.col-md-12.col-lg-12(v-if="['VIP'].includes(target_group)")
            b-form-group(:label="$t('ui.vip')").mb-0
              table
                tr
                  th
                    b-form-checkbox(v-model="allSelectedVIP" @change="selectAllVIP")
                      span.font-weight-bold {{ allSelectedVIP  ? $t('ui.unselect_all') : $t('ui.select_all') }}
                tr(v-for="(row, rowIndex) in rowsVIPList" :key="rowIndex")
                  td(v-for='(p, itemIndex) in row' :key="itemIndex")
                    b-form-checkbox(v-model="vip_list" :value='p.value') {{ p.text }}
              ValidateResult(:value="$v.vip_list" :name="$t('ui.vip')")
            //- b-form-group(:label="$t('ui.vip')").mb-0
            //-   VipLookup(
            //-     ref="vip_id"
            //-     size="sm"
            //-     required
            //-     type="array"
            //-     :dirty="$v.vip_id.$dirty"
            //-     :error="$v.vip_id.$error"
            //-     v-model.trim.lazy="$v.vip_id.$model"
            //-     :disabled="loading"
            //-   )
            //- ValidateResult(:value="$v.vip_id" :name="$tc('ui.vip')")
        .row(v-if="['CUSTOM'].includes(target_group)")
          div.col-sm-12.col-md-12.col-lg-12
            b-form-group(:label="$t('ui.member_list')")
              b-form-textarea.col-12(
                ref="member_list"
                size="sm"
                required
                :dirty="$v.member_list.$dirty"
                :error="$v.member_list.$error"
                v-model.trim.lazy="$v.member_list.$model"
                rows="10"
                max-rows="10"
                trim=true
                :disabled="loading"
                @paste="handlePaste"
              )
            ValidateResult(:value="$v.member_list" :name="$t('ui.member_list')")
      b-card
        .row
          div.col-sm-12.col-md-12.col-lg-12
            div.row
              div.col-sm-12.col-md-12.col-lg-12
                b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 20vh;").mb-0
                  table
                    tr
                      th
                        b-form-checkbox(v-model="allSelected" @change="selectAll")
                          span.font-weight-bold {{ allSelected  ? $t('ui.unselect_all') : $t('ui.select_all') }}
                    tr(v-for="(row, rowIndex) in rowsPList" :key="rowIndex")
                      td(v-for='(p, itemIndex) in row' :key="itemIndex")
                        b-form-checkbox(v-model="provider_list" :value='p.value') {{ p.text }}
                ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import RescueCycle from "@/library/RescueCycle";
import TargetGroup from "@/library/TargetGroup";
import VipLookup from "@/library/VipLookup";
import PayoutMethod from "@/library/PayoutMethod";
import CampaignLookup from "@/library/CampaignLookup";
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    RescueCycle,
    TargetGroup,
    VipLookup,
    PayoutMethod,
    CampaignLookup
  },
  props: {
  },
  data() {
    return {
      rescue_id: "",
      rescue_name: "",
      rescue_rate: "",
      rescue_cycle: "",
      min_lose: 0,
      max_payout: 0,
      start_date: "",
      end_date: "",
      payout_method: "",
      campaign_id: "",
      target_group: "",
      allSelectedVIP: false,
      vip_list: [],
      vipList: [],
      member_list: "",
      provider_list: [],
      providerList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      allSelected: false
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    rowsPList() {
      const rows = [];
      for (let i = 0; i < this.providerList.length; i += 3) {
        rows.push(this.providerList.slice(i, i + 3));
      }
      return rows;
    },
    rowsVIPList() {
      const rows = [];
      for (let i = 0; i < this.vipList.length; i += 8) {
        rows.push(this.vipList.slice(i, i + 8));
      }
      return rows;
    },
  },
  validations() {
    return {
      rescue_id: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20)
      },
      rescue_name: {
        required,
        maxLength: maxLength(100)
      },
      rescue_cycle: {
        required
      },
      rescue_rate: {
        required,
        decimal,
        minValue: minValue(1)
      },
      min_lose: {
        required,
        decimal
      },
      max_payout: {
        required,
        decimal
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      provider_list: {
        atLeastOneProvider,
        minLength: minLength(1)
      },
      payout_method: {
        required
      },
      campaign_id: {
        required: requiredIf(function () {
          return ['INBOX'].includes(this.payout_method);
        })
      },
      target_group: {
        required
      },
      vip_list: {
        minLength(value) {
          if(['VIP'].includes(this.target_group)) {
            return minLength(1)(value)
          } else {
            return minLength(0)(value)
          }
        },
        required: requiredIf(function () {
          return ['VIP'].includes(this.target_group);
        })
      },
      member_list: {
        required: requiredIf(function () {
          return ['CUSTOM'].includes(this.target_group);
        })
      },
    }
  },
  watch : {
    provider_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelected = false;
      else if (newValue.length === this.providerList.length)
        this.allSelected = true;
      else
        this.allSelected = false;
    },
    target_group(newVal) {
      if(['CUSTOM'].includes(newVal))
        this.vip_list = []

      if(['VIP'].includes(newVal))
        this.member_list = ""

      if(['ALL'].includes(newVal)) {
        this.member_list = ""
        this.vip_list = []
      }
    },
    payout_method(newVal) {
      if(!['INBOX'].includes(newVal))
        this.campaign_id = ""
    },
    vip_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelectedVIP = false;
      else if (newValue.length === this.vipList.length)
        this.allSelectedVIP = true;
      else
        this.allSelectedVIP = false;
    },
  },
  methods: {
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.member_list = commaSeparatedData;
    },
    selectAll: function() {
      this.provider_list = [];

      let list = this.providerList;

      if (!this.allSelected) {
        for(var i = 0; i < list.length; i++) {
          this.provider_list.push(list[i].value);
        }
      }
    },
    selectAllVIP: function() {
      this.vip_list = [];

      let list = this.vipList;

      if (!this.allSelectedVIP) {
        for(var i = 0; i < list.length; i++) {
          this.vip_list.push(list[i].value);
        }
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.rescueFundAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          rescue_id: this.rescue_id,
          rescue_name: this.rescue_name,
          rescue_rate: this.rescue_rate,
          rescue_cycle: this.rescue_cycle,
          min_lose: this.min_lose,
          max_payout: this.max_payout,
          start_date: this.start_date,
          end_date: this.end_date,
          payout_method: this.payout_method,
          campaign_id: this.campaign_id,
          target_group: this.target_group,
          vip_list: this.vip_list.toString(),
          member_list: this.member_list,
          audit_by: this.$store.getters.loginId
        };

        if (this.provider_list.length != this.providerList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        // if (this.vip_list.length != this.vipList.length)
        //   json.vip_list = this.removeDuplicate(this.vip_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addRescueFund.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_rescue_fund", this.feedback.status);
                  this.$refs.addRescueFund.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getProviderList: function() {
      let url = config.providerMaintenanceListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_code.toUpperCase(), text: list[i].provider_name, checked: false});
                  }
                  this.providerList = result;
                } else {
                  this.providerList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getVIPList: function() {
      let url = config.vipListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].vip_id, text: list[i].vip_name.toUpperCase(), checked: false});
                  }
                  this.vipList = result;
                } else {
                  this.vipList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.rescue_id = "";
      this.rescue_name = "";
      this.rescue_rate = "";
      this.rescue_cycle = "";
      this.min_lose = 0;
      this.max_payout = 0;
      this.start_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.end_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.provider_list = [];
      this.payout_method = "",
      this.campaign_id = "";
      this.target_group = "";
      this.vip_list = [];
      this.member_list = "";
      this.providerList = [];
      this.getProviderList();
      this.getVIPList();
      this.$refs.rescue_id.$el.focus();
    }
  }
};
</script>
